import React, { useEffect, useState } from 'react';
import {
  Label,
  TextBold,
  TextMedium,
} from '../../../styles/GlobalStyledComponents';
import {
  CardColumExpress,
  CardInputExpress,
  CardList,
  CardSectionExpress,
  CardsWrapper,
  MoreOptionsCardSection,
  MoreOptionsLink,
  PaymentClickCardSection,
  PaymentMethodRow,
} from './PaymentTypesStyledComponents';
import CardIcon from '../../../assets/icons/IconCard';
import BizumIcon from '../../../assets/icons/IconBizum';
import TransferIcon from '../../../assets/icons/IconTransfer';
import {
  PaymentMethod,
  PaymentMethodOrder,
} from '../../../interfaces/PaymentMethod';
import {
  ApplePayLogWrapper,
  CardCheckbox,
  CardColumn,
  CardColumnGoogle,
  CardInput,
  CardInputGoogle,
  CardSection,
  CheckboxContainer,
  CheckboxContainerGoogle,
  GooglePayLogWrapper,
} from '../CardsStyledComponents';
import IconVisa from './../../../assets/icons/IconPayments/IconVisa';
import { PaymentTypesCard } from '../../../interfaces/PaymentTypesCard';
import IconMasterCard from '../../../assets/icons/IconPayments/IconMasterCard';
import IconMaestro from '../../../assets/icons/IconPayments/IconMaestro';
import { PaymentCard } from '../../../interfaces/Loan';

import {
  GooglePayLogoBorder,
  ApplePayLogoBorder,
} from '@pepper/google-apple-pay-react';
import { colors } from '../../../styles/Colors';
import IconBank from '../../../assets/icons/IconBank';

interface PaymentTypesProps {
  method: (data: PaymentMethod) => void;
  cardList?: PaymentCard[];
  cardSelected: (cardData: PaymentCard) => void;
  otherOptionsClick: () => void;
  googleAvailable?: boolean;
  appleAvailable?: boolean;
  bizumAvailable?: boolean;
  resetSelection: boolean;
  retryOrder?: PaymentMethodOrder;
  activeError?: boolean;
}

export const PaymentTypes: React.FC<PaymentTypesProps> = ({
  method,
  cardList,
  cardSelected,
  otherOptionsClick,
  googleAvailable,
  appleAvailable,
  bizumAvailable,
  resetSelection,
  retryOrder = {
    express: 1,
    credit_card: 2,
    bizum: 3,
    bank_account: 4,
    apple: 5,
    google: 6,
    others: 7,
  },
  activeError = false,
}) => {
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>();
  const [selectedCard, setSelectedCard] = useState<PaymentCard | undefined>(
    cardList ? cardList[0] : undefined,
  );
  const { VISA, MASTERCARD, MAESTRO } = PaymentTypesCard;

  const comeFromNoDebt = JSON.parse(
    localStorage.getItem('come-from-nodebt') || 'false',
  );
  const creatingPaymentPlan =
    sessionStorage.getItem('pepper-payment-plan') === 'true';

  const paymentMethodError = sessionStorage.getItem(
    'pepper-payment-method-error',
  );

  const getPaymentMethodStored = () => {
    //Si encuentra un método de pago guardado de antes lo vuelve a seleccionar
    const paymentMethodSelected = sessionStorage.getItem(
      'pepper-payment-method',
    ) as PaymentMethod;
    if (paymentMethodSelected && !activeError && !paymentMethodError) {
      setPaymentMethod(PaymentMethod[`${paymentMethodSelected}`]);
    }
  };

  useEffect(() => {
    resetSelection && setPaymentMethod(undefined);
  }, [resetSelection]);

  useEffect(() => {
    selectedCard && cardSelected(selectedCard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCard]);

  useEffect(() => {
    paymentMethod && method(paymentMethod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethod]);

  useEffect(() => {
    if (cardList && !selectedCard ) {
      setSelectedCard(cardList[0]);
      if (comeFromNoDebt && cardList && cardList.length > 0) {
        setPaymentMethod(PaymentMethod.EXPRESS);
      }
    }
  }, [cardList]);

  useEffect(() => {
    getPaymentMethodStored();
  }, []);

  return (
    <>
      {cardList && cardList?.length > 0 && (
        <CardInputExpress
          onClick={() => setPaymentMethod(PaymentMethod.EXPRESS)}
          selected={paymentMethod === PaymentMethod.EXPRESS}
          borderColor={colors.red7}
          height={paymentMethod !== PaymentMethod.EXPRESS ? '60' : 'auto'}
          id="payment-click-select-btn"
          order={retryOrder?.express}
          hidden={
            !!(
              (retryOrder && !retryOrder?.express)
            )
          }
        >
          <CheckboxContainer>
            <CardCheckbox
              type="radio"
              checked={paymentMethod === PaymentMethod.EXPRESS}
              readOnly
              id="payment-click-express-select-btn-checkbox"
              name="paymentMethodExpress"
            />
            <Label htmlFor="payment-click-express-select-btn-checkbox"></Label>
          </CheckboxContainer>
          <CardColumExpress id="payment-click-select-btn-column">
            <PaymentMethodRow id="payment-click-select-btn-row">
              <PaymentClickCardSection id="payment-click-select-btn-section">
                <TextBold fontSize={14} lineHeight={20}>
                  Paga en un click
                </TextBold>
                {selectedCard && paymentMethod !== PaymentMethod.EXPRESS && (
                  <CardSectionExpress id="payment-click-select-btn-section-express">
                    <TextMedium fontSize={14}>
                      ··· {selectedCard.last_four_digits}
                    </TextMedium>
                    {selectedCard.type === MASTERCARD && <IconMasterCard />}
                    {selectedCard.type === VISA && <IconVisa />}
                    {selectedCard.type === MAESTRO && <IconMaestro />}
                    {/* <ExpirationDate fontSize={12} color="gray6">
                      {' '}
                      Caducidad {selectedCard.expiration_date}
                    </ExpirationDate> */}
                  </CardSectionExpress>
                )}
              </PaymentClickCardSection>
            </PaymentMethodRow>
          </CardColumExpress>
          {paymentMethod === PaymentMethod.EXPRESS && (
            <CardsWrapper id="payment-click-select-btn-wrapper">
              <TextMedium fontSize={14}>
                Selecciona la tarjeta con la que quieres pagar.
              </TextMedium>
              {cardList.map((card: PaymentCard, index) => {
                return (
                  <CardList
                    key={index}
                    onClick={() => setSelectedCard(card)}
                    selected={selectedCard === card}
                    borderColor={colors.red7}
                    id="payment-click-card-select-btn"
                  >
                    <CheckboxContainer id="payment-click-card-select-btn-container">
                      <CardCheckbox
                        type="radio"
                        checked={
                          selectedCard === card &&
                          paymentMethod === PaymentMethod.EXPRESS
                        }
                        readOnly
                        id="payment-click-card-select-btn-checkbox"
                        name="paymentMethodExpress2"
                      />
                      <Label htmlFor="payment-click-card-select-btn-checkbox"></Label>
                    </CheckboxContainer>
                    <TextMedium fontSize={14}>
                      ··· {card.last_four_digits}
                    </TextMedium>
                    {card.type === MASTERCARD && <IconMasterCard />}
                    {card.type === VISA && <IconVisa />}
                    {card.type === MAESTRO && <IconMaestro />}
                    {/* <ExpirationDate fontSize={12} color="gray6">
                      {' '}
                      Caducidad {card.expiration_date}
                    </ExpirationDate> */}
                  </CardList>
                );
              })}
            </CardsWrapper>
          )}
        </CardInputExpress>
      )}
      {/* Seleccionar (otra) tarjeta */}
      <CardInput
        onClick={() => setPaymentMethod(PaymentMethod.CREDIT_CARD)}
        selected={paymentMethod === PaymentMethod.CREDIT_CARD}
        borderColor={colors.red7}
        height={'60'}
        id="card-select-btn"
        order={retryOrder?.credit_card}
        hidden={!!(retryOrder && !retryOrder?.credit_card)}
      >
        <CheckboxContainer id="card-select-btn-container">
          <CardCheckbox
            type="radio"
            checked={paymentMethod === PaymentMethod.CREDIT_CARD}
            readOnly
            id="payment-card-select-btn-checkbox"
            name="paymentMethodCreditCard"
          />
          <Label htmlFor="payment-card-select-btn-checkbox"></Label>
        </CheckboxContainer>
        <CardColumn id="card-select-btn-column">
          <PaymentMethodRow id="card-select-btn-row">
            <CardSection id="card-select-btn-section">
              <TextBold fontSize={14} lineHeight={20}>
                {cardList && cardList?.length > 0
                  ? 'Paga con otra tarjeta'
                  : 'Paga con tarjeta'}
              </TextBold>
            </CardSection>
            <CardSection id="card-select-btn-section-2">
              <CardIcon />
            </CardSection>
          </PaymentMethodRow>
        </CardColumn>
      </CardInput>
      {/* Bizum activated for web and app */}
      {!creatingPaymentPlan && bizumAvailable && (
        // Seleccionar Bizum
        <CardInput
          onClick={() => setPaymentMethod(PaymentMethod.BIZUM)}
          selected={paymentMethod === PaymentMethod.BIZUM}
          borderColor={colors.red7}
          height={'60'}
          id="bizum-select-btn"
          order={retryOrder?.bizum}
          hidden={!!(retryOrder && !retryOrder?.bizum)}
        >
          <CheckboxContainer>
            <CardCheckbox
              type="radio"
              checked={paymentMethod === PaymentMethod.BIZUM}
              readOnly
              id="payment-bizum-select-btn-checkbox"
              name="paymentMethodBizum"
            />
            <Label htmlFor="payment-bizum-select-btn-checkbox"></Label>
          </CheckboxContainer>
          <CardColumn>
            <PaymentMethodRow>
              <CardSection>
                <TextBold fontSize={14} lineHeight={20}>
                  Paga con Bizum
                </TextBold>
              </CardSection>
              <CardSection>
                <BizumIcon />
              </CardSection>
            </PaymentMethodRow>
          </CardColumn>
        </CardInput>
      )}
      {appleAvailable && !creatingPaymentPlan && (
        // Seleccionar Apple Pay
        <CardInput
          onClick={() => setPaymentMethod(PaymentMethod.APPLE)}
          selected={paymentMethod === PaymentMethod.APPLE}
          borderColor={colors.red7}
          height={'60'}
          id="apple-pay-select-btn"
          order={retryOrder?.apple}
          hidden={!!(retryOrder && !retryOrder?.apple)}
        >
          <CheckboxContainer>
            <CardCheckbox
              type="radio"
              checked={paymentMethod === PaymentMethod.APPLE}
              readOnly
              id="payment-apple-select-btn-checkbox"
              name="paymentMethodApple"
            />
            <Label htmlFor="payment-apple-select-btn-checkbox"></Label>
          </CheckboxContainer>
          <CardColumn>
            <PaymentMethodRow>
              <CardSection>
                <TextBold fontSize={14} lineHeight={20}>
                  Apple Pay
                </TextBold>
              </CardSection>
              <ApplePayLogWrapper>
                <ApplePayLogoBorder />
              </ApplePayLogWrapper>
            </PaymentMethodRow>
          </CardColumn>
        </CardInput>
      )}
      {googleAvailable && !creatingPaymentPlan && (
        // Seleccionar Google Pay
        <CardInputGoogle
          onClick={() => setPaymentMethod(PaymentMethod.GOOGLE)}
          selected={paymentMethod === PaymentMethod.GOOGLE}
          borderColor={colors.red7}
          height={'60'}
          id="google-pay-select-btn"
          order={retryOrder?.google}
          hidden={!!(retryOrder && !retryOrder?.google)}
        >
          <CheckboxContainerGoogle id="google-pay-select-btn-container">
            <CardCheckbox
              type="radio"
              checked={paymentMethod === PaymentMethod.GOOGLE}
              readOnly
              id="payment-google-select-btn-checkbox"
              name="paymentMethodGoogle"
            />
            <Label htmlFor="payment-google-select-btn-checkbox"></Label>
          </CheckboxContainerGoogle>
          <CardColumnGoogle id="google-pay-select-btn-column">
            <PaymentMethodRow>
              <CardSection>
                <TextBold fontSize={14} lineHeight={20}>
                  Google Pay
                </TextBold>
              </CardSection>
              <GooglePayLogWrapper>
                <GooglePayLogoBorder />
              </GooglePayLogWrapper>
            </PaymentMethodRow>
          </CardColumnGoogle>
        </CardInputGoogle>
      )}
      {!creatingPaymentPlan && (
        // Seleccionar transferencia bancaria
        <CardInput
          onClick={() => setPaymentMethod(PaymentMethod.BANK_ACCOUNT)}
          selected={paymentMethod === PaymentMethod.BANK_ACCOUNT}
          borderColor={colors.red7}
          height={'60'}
          id="bank-account-select-btn"
          order={retryOrder?.bank_account}
          hidden={!!(retryOrder && !retryOrder?.bank_account)}
        >
          <CheckboxContainer>
            <CardCheckbox
              type="radio"
              checked={paymentMethod === PaymentMethod.BANK_ACCOUNT}
              readOnly
              id="payment-bank-account-select-btn-checkbox"
              name="paymentMethodBankAccount"
            />
            <Label htmlFor="payment-bank-account-select-btn-checkbox"></Label>
          </CheckboxContainer>
          <CardColumn>
            <PaymentMethodRow>
              <CardSection>
                <TextBold fontSize={14} lineHeight={20}>
                  Transferencia online
                </TextBold>
              </CardSection>
              <CardSection>
                <TransferIcon />
              </CardSection>
            </PaymentMethodRow>
          </CardColumn>
        </CardInput>
      )}
      {!creatingPaymentPlan && (
        // Seleccionar otros métodos de pago
        <MoreOptionsLink
          onClick={() => otherOptionsClick()}
          borderColor={colors.red7}
          id="other-options-select-btn"
          order={retryOrder?.others}
          hidden={!!(retryOrder && !retryOrder?.others)}
        >
          <CardColumn id="other-options-select-btn-column">
            <PaymentMethodRow id="other-options-select-btn-row">
              <MoreOptionsCardSection id="other-options-select-btn-section">
                <TextBold fontSize={14} lineHeight={20}>
                  Otras formas de pago
                </TextBold>
              </MoreOptionsCardSection>
              <CardSection>
                <IconBank />
              </CardSection>
            </PaymentMethodRow>
          </CardColumn>
        </MoreOptionsLink>
      )}
    </>
  );
};
